






















































import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'


import { thread as gqlThread } from '@/GraphQL/queries'
import SourceContentInfo from '@/components/SourceContentInfo/SourceContentInfo.vue'

@Component({
  components: { SourceContentInfo },
})
export default class ThreadPage extends Vue {
  @Prop() uid!: string
  gqlThread: string = gqlThread

  onResult(data) {
    this.$nextTick(() => {
      if (data.data.thread.data.length < 2) return

      let secondlastCommentUid = data.data.thread.data[data.data.thread.data.length - 2].uid
      let secondlastCommentEl = document.getElementById(`thread-comment-${secondlastCommentUid}`)
      let commentEl = document.getElementById(`thread-comment-${this.uid}`)
      //56px header; 24px container padding
      // if (commentEl && secondlastCommentEl) {
      //   commentEl.style.setProperty('margin-bottom', `calc(100vh - 56px - 24px - ${commentEl.offsetHeight}px - ${secondlastCommentEl.offsetHeight}px) `, 'important')
      // }
      // this.$vuetify.goTo(`#thread-comment-${secondlastCommentUid}`)
      this.$vuetify.goTo(`#thread-comment-${this.uid}`, { offset: 56 })
    })
  }
}

